import { render, staticRenderFns } from "./IdeaCard.vue?vue&type=template&id=384e1f24&scoped=true"
import script from "./IdeaCard.vue?vue&type=script&lang=js"
export * from "./IdeaCard.vue?vue&type=script&lang=js"
import style0 from "./IdeaCard.vue?vue&type=style&index=0&id=384e1f24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384e1f24",
  null
  
)

export default component.exports